// extracted by mini-css-extract-plugin
export default {"user-management-container":"userManagement_user-management-container__Bks+k"};